import { useEffect, useState } from "react";
import Header from "../../Layout/Header";
import { Box, Divider, useTheme, Grid, Typography, Modal, TextField, Table, TableCell, TableBody, Checkbox, Tooltip, TableContainer, TableHead, TableRow, IconButton, Button, Menu, MenuItem, ListItemIcon, ListItemText, Card, CardContent, CardHeader } from "@mui/material";


import StackAvailableReelListSubMenu from "./StoreReelInStockReelSubMenu";
import CloseIcon from '@mui/icons-material/Close';
import ViewStackingReelReprot from "./StockWiseReelReport";
import { tokens } from "../../theme/theme";
import { callApi } from "../../utils/apiClient";
import { API_ENDPOINTS } from "../../config/api/apiCall";

const StackWiseStockList = ({ stack_identification_number, handlecallbackstackList, selectedLocationCode }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);


    const [paymentTerms, setPaymentTerms] = useState([]);
    const [paymentTermAnchorEl, setPaymentTermAnchorEl] = useState(null);
    const [selectedPaymentTerm, setSelectedPaymentTerm] = useState(null);
    const [paymentTermFilterText, setPaymentTermFilterText] = useState('');
    const [paymentTermsID, setPaymentTermsID] = useState(0);

    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState('All');
    const [slotList, setSlotList] = useState([]);
    const [childRollDetails, setChildRollDetails] = useState([]);
    const [allChildRollDetails, setAllChildRollDetails] = useState([]);

    const [viewAvailableSlots, setViewAvailableSlots] = useState(true);
    const [viewStackingReelReport, SetViewStackingReelReport] = useState(false);
    const [viewAvailableReelList, SetViewAvailableReelList] = useState(false);
    const [showCard, setShowCard] = useState(false);

    const [selectedStackingID, setSelectedStackingID] = useState(0);
    const [selectedLevel, setSelectedLevel] = useState(0);


    const [open, setOpen] = useState(false);

    const handleOpenMenu = (setter) => (event) => {
        setter(event.currentTarget);
    };

    const handleCloseMenu = (setter) => () => {
        setter(null);
    };

    const handleSelectOption = (setSelectedOption, setSelectedID) => (option) => {
        setSelectedOption(option);
        setSelectedID(option ? option.id : null);
        handleCloseMenu();
    };


    const [isPaymentTermDialogOpen, setPaymentTermDialogOpen] = useState(false);

    const handleAddOption = (label) => () => {
        if (label == 'Warehouse') {
            setPaymentTermDialogOpen(true);
        }
    };


    // API CALL WARE    HOUSE LIST
    const [isDataLoaded, setIsDataLoaded] = useState(false);

    useEffect(() => {
        if (!isDataLoaded) {

            const para = {
                p_companyid: 1,
            }

            callApi(API_ENDPOINTS.WAREHOUSE_GET_LIST, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data && data.length > 0) {
                        setPaymentTerms(data);
                    }
                })
                .catch(error => {
                    alert(error.message);
                });

        }
    }, [isDataLoaded]);


    useEffect(() => {
        if (stack_identification_number) {

            LoadAvailableSlotList();

        }
    }, [stack_identification_number]);


    const LoadAvailableSlotList = () => {
        const para = {
            p_companyid: 1,
            p_id_stacking: stack_identification_number,
        }

        callApi(API_ENDPOINTS.WAREHOUSE_GET_STACK_WISE_ALLOCATED_REEL, 'POST', { 'Content-Type': 'application/json' }, para)
            .then(data => {
                if (data && data.length > 0) {
                    setSlotList(data);
                }
                else {
                    setSlotList([]);
                }
            })
            .catch(error => {
                alert(error.message);
            });
    }



    const callback = () => {
        handlecallbackstackList();
    }


    // slot list
    const [filters, setFilters] = useState({
        name: '',
        companyname: '',
        email: '',
        workphone: '',
        status: '',
        payales: '',
    });

    const filteredData = slotList.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'Open' || row.status === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });


    const SelectedRowValues = (warehouse_id, zone_id, aisle_id, stacking_id, location, level) => {
        const location_values = 0;
        setSelectedStackingID(stacking_id);
        // setSelectedLocationCode(location);
        setSelectedLevel(level);
        setViewAvailableSlots(false);
        SetViewAvailableReelList(false);
        // SetViewAddReelToStock(true);

    };

    const callBackLockReel = () => {
        setSelectedStackingID(0);
        setViewAvailableSlots(true);
        SetViewAvailableReelList(false);
        // SetViewAddReelToStock(false);
        LoadAvailableSlotList();
    };

    const [selectedButtonName, setSelectedButtonName] = useState('StackingReels');

    const handlecallProcess = (buttonName) => {
        if (buttonName === 'StackingReels') {

            setViewAvailableSlots(true);
            SetViewAvailableReelList(false);
            SetViewStackingReelReport(false);

        }
        else if (buttonName == 'All Reel') {
            setViewAvailableSlots(false);
            SetViewAvailableReelList(true);
            SetViewStackingReelReport(false);
            AllChildRollCompleteDetails(stack_identification_number);
        }
        else if (buttonName === 'PDF') {
            setViewAvailableSlots(false);
            SetViewAvailableReelList(false);
            AllChildRollCompleteDetails(stack_identification_number);
            SetViewStackingReelReport(true);          


        }
        else if (buttonName === 'Email') {
            //   setOpenPreviewModal(true);
        }

    };




    const ChildRollCompleteDetails = async (child_roll_id) => {
        try {
            const para = { p_companyid: 1, p_id_child_reel: child_roll_id, }
            const data = await callApi(API_ENDPOINTS.WAREHOUSE_GET_STACK_WISE_ALLOCATED_REEL_COMPLETE_DETAIL, 'POST', { 'Content-Type': 'application/json' }, para);
            if (data && data.length > 0) {
                setChildRollDetails(data);
                setShowCard(true);
                setViewAvailableSlots(false);
                SetViewAvailableReelList(false);
            }
            else { setChildRollDetails([]); }
        }
        catch (error) { alert(error); }

    };

    const AllChildRollCompleteDetails = async (id_stacking) => {
        try {
            const para = { p_companyid: 1, p_id_stacking: id_stacking, }
            const data = await callApi(API_ENDPOINTS.WAREHOUSE_GET_STACK_WISE_ALLOCATED_ALL_REEL_COMPLETE_DETAIL, 'POST', { 'Content-Type': 'application/json' }, para);
            if (data && data.length > 0) { setAllChildRollDetails(data); }
            else { setAllChildRollDetails([]); }
        }
        catch (error) { alert(error); }

    };

    const formatDate = (dateString) => {
        if (!dateString) return "N/A";
        const date = new Date(dateString);
        return date.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        }).replace(/ /g, "-"); // Replace spaces with hyphens
    };

    const handleHide = () => {
        setShowCard(false);
        setViewAvailableSlots(true);
        SetViewAvailableReelList(false);
    };



    return (
        <Box>


            <Header title={'Available Reels in ' + selectedLocationCode} subtitle="" callback={callback} />
            <Divider />
            <StackAvailableReelListSubMenu selectedButtonName={selectedButtonName} setSelectedButtonName={setSelectedButtonName} handlecallProcess={handlecallProcess} />
            <Divider />
            {viewAvailableSlots && (
                <>

                    <Box
                        sx={{
                            padding: "1px",
                            borderRadius: "10px",
                            maxHeight: {
                                xs: '72vh', // Extra small devices (phones)
                                sm: '72vh', // Small devices (tablets)
                                md: '74vh', // Medium devices (small laptops)
                                lg: '74vh', // Large devices (desktops)
                                xl: '82vh', // Extra large devices (large desktops)
                            },
                            overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
                            '&::-webkit-scrollbar': {
                                width: '8px',
                            },
                            '&::-webkit-scrollbar-track': {
                                background: colors.primary[400],
                                borderRadius: '10px',
                            },
                            '&::-webkit-scrollbar-thumb': {
                                background: colors.blueAccent[600],
                                borderRadius: '10px',
                                '&:hover': {
                                    background: colors.blueAccent[800],
                                },
                            },
                            '&::-webkit-scrollbar-corner': {
                                background: colors.primary[700],
                            }
                        }}>

                        <Grid container  >
                            <Grid mt={1} item xs={12} sm={12} md={12} lg={12} xl={12}   >




                                <Grid container padding="15px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                    <Box
                                        gridColumn="span 9"
                                        gridRow={"span 2"}
                                        alignItems="center"
                                        justifyContent="center"
                                        padding={1}
                                        sx={{
                                            "& .MuiTable-root": {
                                                border: "none",
                                                size: "small",
                                            },
                                            "& .MuiTableCell-root": {
                                                borderBottom: "none",
                                                border: "1px solid ",
                                                borderColor: `${colors.primary[400]} !important`,
                                            },
                                            "& .name-column--cell": {
                                                color: colors.greenAccent[300],
                                            },
                                            "& .MuiTableHead-root": {
                                                borderBottom: "none",
                                            },
                                            "& .MuiTableBody-root": {
                                                overflowY: "auto",
                                            },
                                            "& .MuiCheckbox-root": {
                                                color: `${colors.blueAccent[200]} !important`,
                                                size: "small",
                                            },
                                            "& .MuiTableFooter-root": {
                                                borderTop: "none",
                                                backgroundColor: colors.blueAccent[700],
                                                height: "10px",
                                            },
                                            "& .MuiButton-text": {
                                                color: `${colors.grey[100]} !important`,
                                            },

                                        }}>

                                        <TableContainer >
                                            <Table size="small">
                                                <TableHead sx={{ height: 10 }}>
                                                    <TableRow>

                                                        {/* <TableCell>STACKING POSITION</TableCell> */}
                                                        <TableCell>STACK LEVEL</TableCell>
                                                        <TableCell>REEL CODE</TableCell>
                                                        <TableCell>REEL SIZE</TableCell>
                                                        <TableCell>SIZE</TableCell>
                                                        <TableCell>QUALITY</TableCell>
                                                        <TableCell>GSM</TableCell>
                                                        <TableCell>DIAMETER</TableCell>
                                                        <TableCell>CORE</TableCell>
                                                        <TableCell>REEL WEIGHT</TableCell>
                                                        <TableCell>
                                                            {/* <IconButton onClick={handleOpen}>
                                            <Searchicon style={{ fontSize: "16px" }} />
                                        </IconButton> */}
                                                            <Modal
                                                                open={open}
                                                                // onClose={handleClose}
                                                                aria-labelledby="modal-modal-title"
                                                                aria-describedby="modal-modal-description"
                                                            >
                                                                <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'background.paper', boxShadow: 24, p: 4, minWidth: 300 }}>
                                                                    <TextField
                                                                        label="NAME"
                                                                        name="name"
                                                                        value={slotList.warehouse_name}
                                                                        // onChange={handleFilterChange}
                                                                        variant="outlined"
                                                                        fullWidth
                                                                        margin="normal"
                                                                    />
                                                                    <TextField
                                                                        label="Company Name"
                                                                        name="companyName"
                                                                        value={slotList.companyname}
                                                                        //onChange={handleFilterChange}
                                                                        variant="outlined"
                                                                        fullWidth
                                                                        margin="normal"
                                                                    />
                                                                    <TextField
                                                                        label="Email"
                                                                        name="email"
                                                                        value={slotList.email}
                                                                        // onChange={handleFilterChange}
                                                                        variant="outlined"
                                                                        fullWidth
                                                                        margin="normal"
                                                                    />
                                                                    <TextField
                                                                        label="WorkPhone"
                                                                        name="workPhone"
                                                                        value={slotList.workphone}
                                                                        // onChange={handleFilterChange}
                                                                        variant="outlined"
                                                                        fullWidth
                                                                        margin="normal"
                                                                    />
                                                                    <TextField
                                                                        label="Status"
                                                                        name="status"
                                                                        value={slotList.status}
                                                                        // onChange={handleFilterChange}
                                                                        variant="outlined"
                                                                        fullWidth
                                                                        margin="normal"
                                                                    />
                                                                    <TextField
                                                                        label="Payables"
                                                                        name="payables"
                                                                        value={slotList.payales}
                                                                        //onChange={handleFilterChange}
                                                                        variant="outlined"
                                                                        fullWidth
                                                                        margin="normal"
                                                                    />

                                                                    {/* <Button variant="contained" onClick={handleClose} style={{ marginTop: 10 }}>
                                                    Apply Filter
                                                </Button> */}
                                                                </Box>
                                                            </Modal>
                                                        </TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {slotList.map((row) => (
                                                        <TableRow key={row.id}>


                                                            <TableCell>
                                                                <span
                                                                    style={{ color: 'teal', textDecoration: 'underline', cursor: 'pointer' }}
                                                                    onClick={() => ChildRollCompleteDetails(row.child_reel_id)}
                                                                >
                                                                    {row.stacking_level}
                                                                </span>
                                                            </TableCell>

                                                            <TableCell>{row.cr_number}</TableCell>
                                                            <TableCell>{row.master_reel}</TableCell>
                                                            <TableCell>{`${row.width} X ${row.length}`}</TableCell>
                                                            <TableCell>{row.item_code}</TableCell>
                                                            <TableCell>{row.gsm}</TableCell>

                                                            <TableCell>{row.reel_od}</TableCell>
                                                            <TableCell>{row.core_id}</TableCell>
                                                            <TableCell>{row.achieved_qty}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Box>
                                </Grid>
                            </Grid>

                        </Grid>

                    </Box>
                </>
            )}


            {viewAvailableReelList && (
                <Box
                    sx={{
                        padding: "1px",
                        borderRadius: "10px",
                        maxHeight: {
                            xs: '72vh', // Extra small devices (phones)
                            sm: '72vh', // Small devices (tablets)
                            md: '74vh', // Medium devices (small laptops)
                            lg: '74vh', // Large devices (desktops)
                            xl: '82vh', // Extra large devices (large desktops)
                        },
                        overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
                        '&::-webkit-scrollbar': {
                            width: '8px',
                        },
                        '&::-webkit-scrollbar-track': {
                            background: colors.primary[400],
                            borderRadius: '10px',
                        },
                        '&::-webkit-scrollbar-thumb': {
                            background: colors.blueAccent[600],
                            borderRadius: '10px',
                            '&:hover': {
                                background: colors.blueAccent[800],
                            },
                        },
                        '&::-webkit-scrollbar-corner': {
                            background: colors.primary[700],
                        }
                    }}>

                    <Grid container  >
                        <Grid mt={1} item xs={12} sm={12} md={12} lg={12} xl={12}   >




                            <Grid container padding="15px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                <Box
                                    gridColumn="span 9"
                                    gridRow={"span 2"}
                                    alignItems="center"
                                    justifyContent="center"
                                    padding={1}
                                    sx={{
                                        "& .MuiTable-root": {
                                            border: "none",
                                            size: "small",
                                        },
                                        "& .MuiTableCell-root": {
                                            borderBottom: "none",
                                            border: "1px solid ",
                                            borderColor: `${colors.primary[400]} !important`,
                                        },
                                        "& .name-column--cell": {
                                            color: colors.greenAccent[300],
                                        },
                                        "& .MuiTableHead-root": {
                                            borderBottom: "none",
                                        },
                                        "& .MuiTableBody-root": {
                                            overflowY: "auto",
                                        },
                                        "& .MuiCheckbox-root": {
                                            color: `${colors.blueAccent[200]} !important`,
                                            size: "small",
                                        },
                                        "& .MuiTableFooter-root": {
                                            borderTop: "none",
                                            backgroundColor: colors.blueAccent[700],
                                            height: "10px",
                                        },
                                        "& .MuiButton-text": {
                                            color: `${colors.grey[100]} !important`,
                                        },

                                    }}>

                                    <TableContainer >
                                        <Table size="small">
                                            <TableHead sx={{ height: 10 }}>
                                                <TableRow>

                                                    {/* <TableCell>STACKING POSITION</TableCell> */}
                                                    <TableCell>STACK LEVEL</TableCell>
                                                    <TableCell>REEL CODE</TableCell>
                                                    <TableCell>REEL SIZE</TableCell>
                                                    <TableCell>SIZE</TableCell>
                                                    <TableCell>QUALITY</TableCell>
                                                    <TableCell>GSM</TableCell>
                                                    <TableCell>DIAMETER</TableCell>
                                                    <TableCell>CORE</TableCell>
                                                    <TableCell>REEL WEIGHT</TableCell>
                                                    <TableCell>CUSTOMER CODE</TableCell>
                                                    <TableCell>SUPPLIER CODE</TableCell>
                                                    <TableCell>INDENT NUMBER</TableCell>
                                                    <TableCell>INDENT DATE</TableCell>
                                                    <TableCell>LINE NUMBER</TableCell>
                                                    <TableCell>MO NUMBER</TableCell>
                                                    <TableCell>
                                                        {/* <IconButton onClick={handleOpen}>
                                            <Searchicon style={{ fontSize: "16px" }} />
                                        </IconButton> */}
                                                        <Modal
                                                            open={open}
                                                            // onClose={handleClose}
                                                            aria-labelledby="modal-modal-title"
                                                            aria-describedby="modal-modal-description"
                                                        >
                                                            <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'background.paper', boxShadow: 24, p: 4, minWidth: 300 }}>
                                                                <TextField
                                                                    label="NAME"
                                                                    name="name"
                                                                    value={slotList.warehouse_name}
                                                                    // onChange={handleFilterChange}
                                                                    variant="outlined"
                                                                    fullWidth
                                                                    margin="normal"
                                                                />
                                                                <TextField
                                                                    label="Company Name"
                                                                    name="companyName"
                                                                    value={slotList.companyname}
                                                                    //onChange={handleFilterChange}
                                                                    variant="outlined"
                                                                    fullWidth
                                                                    margin="normal"
                                                                />
                                                                <TextField
                                                                    label="Email"
                                                                    name="email"
                                                                    value={slotList.email}
                                                                    // onChange={handleFilterChange}
                                                                    variant="outlined"
                                                                    fullWidth
                                                                    margin="normal"
                                                                />
                                                                <TextField
                                                                    label="WorkPhone"
                                                                    name="workPhone"
                                                                    value={slotList.workphone}
                                                                    // onChange={handleFilterChange}
                                                                    variant="outlined"
                                                                    fullWidth
                                                                    margin="normal"
                                                                />
                                                                <TextField
                                                                    label="Status"
                                                                    name="status"
                                                                    value={slotList.status}
                                                                    // onChange={handleFilterChange}
                                                                    variant="outlined"
                                                                    fullWidth
                                                                    margin="normal"
                                                                />
                                                                <TextField
                                                                    label="Payables"
                                                                    name="payables"
                                                                    value={slotList.payales}
                                                                    //onChange={handleFilterChange}
                                                                    variant="outlined"
                                                                    fullWidth
                                                                    margin="normal"
                                                                />

                                                                {/* <Button variant="contained" onClick={handleClose} style={{ marginTop: 10 }}>
                                                    Apply Filter
                                                </Button> */}
                                                            </Box>
                                                        </Modal>
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {allChildRollDetails.map((row) => (
                                                    <TableRow key={row.id}>


                                                        <TableCell>
                                                            <span
                                                                style={{ color: 'teal', textDecoration: 'underline', cursor: 'pointer' }}
                                                                onClick={() => ChildRollCompleteDetails(row.child_reel_id)}
                                                            >
                                                                {row.stacking_level}
                                                            </span>
                                                        </TableCell>

                                                        <TableCell>{row.cr_number}</TableCell>
                                                        <TableCell>{row.master_reel}</TableCell>
                                                        <TableCell>{`${row.d_width} X ${row.d_length}`}</TableCell>
                                                        <TableCell>{row.quality}</TableCell>
                                                        <TableCell>{row.gsm}</TableCell>

                                                        <TableCell>{row.diameter}</TableCell>
                                                        <TableCell>{row.inner_core}</TableCell>
                                                        <TableCell>{row.achieved_qty}</TableCell>
                                                        <TableCell>{row.customer_name}</TableCell>
                                                        <TableCell>{row.supplier_name}</TableCell>
                                                        <TableCell>{row.indent_no}</TableCell>
                                                        <TableCell>{formatDate(row.indent_date)}</TableCell>
                                                        <TableCell>{row.line_no}</TableCell>
                                                        <TableCell>{row.mo_number}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Box>
                            </Grid>
                        </Grid>

                    </Grid>

                </Box>
            )}

            {/* <Divider /> */}
            <Box padding={5} sx={{ backgroundColor: "transparent" }} >
                {/* <Divider /> */}

                {showCard && (
                    <Card sx={{ borderRadius: "10px", padding: 2, boxShadow: 3, backgroundColor: "transparent" }}>
                        <CardHeader
                            title={`Reel Details - CR Number: ${childRollDetails?.[0]?.cr_number || 0}`}
                            sx={{ backgroundColor: "#009688", padding: 2, borderRadius: "10px 10px 0 0" }}
                            action={
                                <IconButton onClick={handleHide}>
                                    <CloseIcon style={{ color: "#fff" }} />
                                </IconButton>
                            }
                        />
                        <Divider />
                        <CardContent>
                            <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    <Typography variant="subtitle1" color="textSecondary">
                                        Customer Name:
                                    </Typography>
                                    <Typography variant="body1">{childRollDetails?.[0]?.customer_name || "N/A"}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="subtitle1" color="textSecondary">
                                        Supplier Name:
                                    </Typography>
                                    <Typography variant="body1">{childRollDetails?.[0]?.supplier_name || "N/A"}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="subtitle1" color="textSecondary">
                                        Indent Number:
                                    </Typography>
                                    <Typography variant="body1">{childRollDetails?.[0]?.indent_no || "N/A"}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="subtitle1" color="textSecondary">
                                        Indent Date:
                                    </Typography>
                                    <Typography variant="body1">{formatDate(childRollDetails?.[0]?.indent_date) || "N/A"}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="subtitle1" color="textSecondary">
                                        Line Number:
                                    </Typography>
                                    <Typography variant="body1">{childRollDetails?.[0]?.line_no || "N/A"}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="subtitle1" color="textSecondary">
                                        Master Reel:
                                    </Typography>
                                    <Typography variant="body1">{childRollDetails?.[0]?.master_reel || "N/A"}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="subtitle1" color="textSecondary">
                                        Width:
                                    </Typography>
                                    <Typography variant="body1">{childRollDetails?.[0]?.d_width || "N/A"}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="subtitle1" color="textSecondary">
                                        Quality:
                                    </Typography>
                                    <Typography variant="body1">{childRollDetails?.[0]?.quality || "N/A"}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="subtitle1" color="textSecondary">
                                        GSM:
                                    </Typography>
                                    <Typography variant="body1">{childRollDetails?.[0]?.gsm || "N/A"}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="subtitle1" color="textSecondary">
                                        Diameter:
                                    </Typography>
                                    <Typography variant="body1">{childRollDetails?.[0]?.diameter || "N/A"}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="subtitle1" color="textSecondary">
                                        Inner Core:
                                    </Typography>
                                    <Typography variant="body1">{childRollDetails?.[0]?.inner_core || "N/A"}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="subtitle1" color="textSecondary">
                                        Reel Length:
                                    </Typography>
                                    <Typography variant="body1">{childRollDetails?.[0]?.reel_length || "N/A"}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="subtitle1" color="textSecondary">
                                        Reel Weight:
                                    </Typography>
                                    <Typography variant="body1">{childRollDetails?.[0]?.achieved_qty || "N/A"}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="subtitle1" color="textSecondary">
                                        Produced MO Number:
                                    </Typography>
                                    <Typography variant="body1">{childRollDetails?.[0]?.mo_number || "N/A"}</Typography>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                )}


                {viewStackingReelReport && (

                    // <Box sx={{
                    //     // backgroundColor: colors.primary[700],
                    //     padding: "5px",
                    //     borderRadius: "10px",
                    //     maxHeight: {
                    //         xs: '72vh', // Extra small devices (phones)
                    //         sm: '72vh', // Small devices (tablets)
                    //         md: '74vh', // Medium devices (small laptops)
                    //         lg: '74vh', // Large devices (desktops)
                    //         xl: '84vh', // Extra large devices (large desktops)
                    //     },
                    //     overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
                    //     '&::-webkit-scrollbar': {
                    //         width: '8px',
                    //     },
                    //     '&::-webkit-scrollbar-track': {
                    //         background: colors.primary[400],
                    //         borderRadius: '10px',
                    //     },
                    //     '&::-webkit-scrollbar-thumb': {
                    //         background: colors.blueAccent[600],
                    //         borderRadius: '10px',
                    //         '&:hover': {
                    //             background: colors.blueAccent[800],
                    //         },
                    //     },
                    //     '&::-webkit-scrollbar-corner': {
                    //         background: colors.primary[700],
                    //     }
                    // }}>
                        <ViewStackingReelReprot stackingReelList={allChildRollDetails} stackingLocation={selectedLocationCode} />
                    // </Box>


                )}


            </Box>






        </Box>
    );
}
export default StackWiseStockList